const state = {
  balance: 0,
  intent: {
    id: '',
    clientSecret: '',
  },
  plans: [],
  plan: {
    id: null,
    prepaid: null,
    name: null,
    price: null,
    price_per_consultation: null,
  },
  lastBuy: {
    order: '',
    slipUrl: null,
  },
  paymentMethods: [],
};

export default state;
